import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const strategies = {
  pause: {
    title: 't(Pause Subscription)',
    text: 't(I’d like to pause my subscription for now)'
  },
  downgrade: {
    title: 't(Downgrade Subscription)',
    text: 't(I want to downgrade to the Essentials/DIY plan)'
  },
  cancel: {
    title: 't(Cancel Subscription)',
    text: 't(I\'d still want to subscription my account)'
  },
}

const StrategyToken = ({ value }) => (
  <div className="token">
    <strong><T text={ strategies[value].title } /></strong><br />
    <T text={ strategies[value].text } />
  </div>
)

StrategyToken.propTypes = {
  value: PropTypes.string
}

export default StrategyToken
